import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Active } from '../../../../model/Statuses';
import { ROOT_NODE_ID, SelectionMode } from '../DynamicTree';

class CommonActionsTree extends React.Component {
  static propTypes = {
    tree: PropTypes.string.isRequired,
    onSelectionChange: PropTypes.func.isRequired,

    value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    children: PropTypes.func,

    selectionMode: PropTypes.oneOf(_.values(SelectionMode)),

    isSyntheticRootNodeAlwaysVisible: PropTypes.bool,
    hasSyntheticRootNode: PropTypes.bool,
    syntheticRootNodeName: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]),

    isModalOpen: PropTypes.bool,

    hasFilter: PropTypes.bool,
    filter: PropTypes.shape({
      value: PropTypes.object,
      searchQuery: PropTypes.string,
      status: PropTypes.string,
    }),
  };

  static defaultProps = {
    syntheticRootNodeName: 'Synthetic Root Node',
    hasSyntheticRootNode: false,
    value: null,
    children: null,
    selectionMode: null,
    hasFilter: true,
    filter: {},
    isModalOpen: true,
    isSyntheticRootNodeAlwaysVisible: true,
  };

  constructor(props) {
    super(props);

    const { hasSyntheticRootNode, syntheticRootNodeName } = props;

    this.SyntheticRootNode = {
      id: ROOT_NODE_ID,
      name: syntheticRootNodeName,
      parentId: null,
      status: Active.value,
    };

    /* eslint-disable react/no-unused-state */
    this.state = {
      rootModels: hasSyntheticRootNode ? [this.SyntheticRootNode] : [],
      filter: { status: Active.value, searchQuery: '' },
    };
    /* eslint-enable react/no-unused-state */
  }

  static getDerivedStateFromProps(props, state) {
    return !props.isModalOpen && props.filter.value === null
      ? _.merge({}, state, { filter: { searchQuery: '' } })
      : null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const oldFilter = this.props.filter.value || this.state.filter;
    const newFilter = nextProps.filter.value || nextState.filter;

    return (
      !_.isEqual(this.props, nextProps) || !_.isEqual(oldFilter, newFilter)
    );
  }

  handleFilterChange = filter => {
    const {
      filter: { value, onChange },
    } = this.props;

    onChange && onChange(filter);
    !value && this.setState({ filter: { ...filter } });
  };
}

export default CommonActionsTree;
